import { Vector2Utils } from '../../../Types/IVector2';
var BreadthFirstPathfinder = (function () {
    function BreadthFirstPathfinder() {
    }
    BreadthFirstPathfinder.search = function (graph, start, goal, cameFrom) {
        var frontier = [];
        var visited = new Set();
        var pathMap = cameFrom || new Map();
        var startHash = Vector2Utils.toHash(start);
        var goalHash = Vector2Utils.toHash(goal);
        if (startHash === goalHash) {
            return true;
        }
        frontier.push(start);
        visited.add(startHash);
        while (frontier.length > 0) {
            var current = frontier.shift();
            var currentHash = Vector2Utils.toHash(current);
            if (currentHash === goalHash) {
                return true;
            }
            for (var _i = 0, _a = graph.getNeighbors(current); _i < _a.length; _i++) {
                var neighbor = _a[_i];
                var neighborHash = Vector2Utils.toHash(neighbor);
                if (visited.has(neighborHash)) {
                    continue;
                }
                visited.add(neighborHash);
                pathMap.set(neighborHash, current);
                frontier.push(neighbor);
            }
        }
        return false;
    };
    BreadthFirstPathfinder.searchPath = function (graph, start, goal) {
        var cameFrom = new Map();
        if (this.search(graph, start, goal, cameFrom)) {
            return this.reconstructPath(cameFrom, start, goal);
        }
        return [];
    };
    BreadthFirstPathfinder.reconstructPath = function (cameFrom, start, goal) {
        var path = [];
        var current = goal;
        var startHash = Vector2Utils.toHash(start);
        while (Vector2Utils.toHash(current) !== startHash) {
            path.unshift(current);
            var currentHash = Vector2Utils.toHash(current);
            var parent_1 = cameFrom.get(currentHash);
            if (!parent_1)
                break;
            current = parent_1;
        }
        path.unshift(start);
        return path;
    };
    return BreadthFirstPathfinder;
}());
export { BreadthFirstPathfinder };
